'use strict';

import $ from 'jquery';
import productSlideshow from '../../common/person-slideshow';
import AccordionModel from './company-index-accordion-model';
import screenSize from '../../common/screen_size_util';

class AccordionCollectionView {

    constructor() {
        this.$productIndexLetters = $('.company-index-letter');
        this.$productContainer = $('.company-container');
        this.$arrow = $('.arrow');
        this.$letterPreview = $('.letter-preview');
        this.size = screenSize.getSize();
    }

    init() {
        this.$productIndexLetters.one('click', (e) => this.initializeSlideshow(e));
        this.$productIndexLetters.click(this.changeArrow);
    }

    populateSmallSlides(groups, slideShow, slideShowPage, finalMarkup) {
        for (let i = 0; i < groups.length; i++) {
            if (i > 0) {
                slideShow.push(slideShowPage);
                slideShowPage = [];
            }
            slideShowPage.push(groups[i]);
        }


        slideShow.push(slideShowPage);
        for (let i = 0; i < slideShow.length; i++) {
            let page = slideShow[i];
            let column1 = page[0] ? page[0].join('') : '';

            finalMarkup += `
                <div class="product-column-container slide">
                    <div class="product-column">${column1}</div>
                </div>
            `;
        }
        return finalMarkup;
    }

    populateLargeSlides(groups, slideShow, slideShowPage, finalMarkup) {
        for (let i = 0; i < groups.length; i++) {
            if ((i % 3) === 0 && i > 0) {
                slideShow.push(slideShowPage);
                slideShowPage = [];
            }
            slideShowPage.push(groups[i]);
        }

        slideShow.push(slideShowPage);

        for (let i = 0; i < slideShow.length; i++) {
            let page = slideShow[i];
            let column1 = page[0] ? page[0].join('') : '';
            let column2 = page[1] ? page[1].join('') : '';
            let column3 = page[2] ? page[2].join('') : '';

            finalMarkup += `
                <div class="product-column-container slide">
                   <div class="product-column">${column1}</div>
                   <div class="product-column">${column2}</div>
                   <div class="product-column">${column3}</div>
               </div>
           `;

        }
        return finalMarkup;
    }

    populateSlides(data, e) {
        const groups = [];
        let currentGroup = [];
        const len = data.rows.length;

        for (let i = 0; i < len; i++) {
            let currentItem = data.rows[i];
            if (i  % 10  === 0 && i > 0) {
                groups.push(currentGroup);
                currentGroup = [];
            }
            currentGroup.push(`
                <div class="list-product">
                    <div class="product">
                        <h4 class="product-name">
                            <a href="/company/${currentItem.url}">${currentItem.name}</a>
                        </h4>
                    </div>
                </div>
            `);
        }
        groups.push(currentGroup);

        // Let's join the data every 3 groups which is a slideshow page
        const slideShow = [];
        const slideShowPage = [];

        let finalMarkup = ``;

        if (this.size === 'small') {
            finalMarkup = this.populateSmallSlides(groups, slideShow, slideShowPage, finalMarkup);
        } else {
            finalMarkup = this.populateLargeSlides(groups, slideShow, slideShowPage, finalMarkup);

        }

        if (!$(e.currentTarget).hasClass('slick-initialized')) {
            $(e.currentTarget).find('.company-list').append(finalMarkup);
        }

        return finalMarkup;
    }
    buildSlides(e, model) {
        return (data) => {
            this.populateSlides(data, e);

            return productSlideshow(e.currentTarget.id, model, this);

        };
    }
    initializeSlideshow(e) {
        let letter = $(e.currentTarget).data('letter');
        if (letter) {
            let encodededLetter = encodeURIComponent(letter);
            let accordionModel  = new AccordionModel(encodededLetter);
            if (!accordionModel.finished) {
                accordionModel
                .get()
                .then(this.buildSlides(e, accordionModel))
                .catch(function (error) {
                    accordionModel.setFinishedState();
                    console.error(error); // eslint-disable-line no-console
                });
            }
        }

    }

    changeArrow(e) {
        if ($(e.target).is('a') || $(e.target).parent().is('a') || $(e.target).is('button') || !$(e.currentTarget).data('letter')) {
            return;
        }

        $(e.currentTarget).find('.company-container').slideToggle(300);
        $(e.currentTarget).find('.arrow').toggleClass('arrow-down');
        $(e.currentTarget).find('.letter-preview').toggleClass('letter-preview-hidden');
    }
}

export default new AccordionCollectionView();
